export default class SmoothScroll {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.container = this.DOM.el.dataset.scrollContainer ? document.querySelector(this.DOM.el.dataset.scrollContainer) : window;

        const href = this.DOM.el.getAttribute('href');
        const fragment = href.includes('#') ? href.split('#')[1] : null;
        this.DOM.target = fragment ? document.querySelector(`#${fragment}`) : null;
        this.DOM.mainHeader = document.querySelector('#main-header');
        this.scrollOffset = parseInt(this.DOM.el.getAttribute('data-smooth-scroll')) || 0;

        if (this.DOM.target) {
            this.initEvents();
        }
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener('click', (e) => {
            e.preventDefault();

            this.DOM.container.scroll({
                top: this.DOM.target.offsetTop - this.DOM.mainHeader.clientHeight - this.scrollOffset,
                left: 0,
                behavior: 'smooth',
            });
        });
    }
}

const smoothScrollNodes = Array.from(document.querySelectorAll('[data-smooth-scroll]'));
if (smoothScrollNodes.length > 0) {
    smoothScrollNodes.forEach((node) => {
        new SmoothScroll(node);
    });
}
